import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import JobDelete from "./JobDelete";
import EditJob from "../EditJob";

const JobActionButton = ({ id, handleDelete, fetchJobs }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showView, setShowView] = useState(false);
  const params = useParams();
  const businessId = params?.business_id;

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };

  return (
    <>
      <span>
        <FontAwesomeIcon
          icon={faEdit}
          size="1x"
          onClick={toggleShowModal}
          data-toggle="modal"
          data-target="#editJob"
        />
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <FontAwesomeIcon
          onClick={toggleDeleteModal}
          icon={faTrash}
          size="1x"
          data-toggle="modal"
          data-target="#deleteJob"
        />
      </span>

      {showDelete && (
        <JobDelete
          jobId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )}

      {showView && (
        <EditJob
          jobId={id}
          businessId={businessId}
          toggleShowModal={toggleShowModal}
          fetchJobs={fetchJobs}
          showView={showView}
        />
      )}
    </>
  );
};

export default JobActionButton;
